// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__AX3di","dimmed":"styles_dimmed__INGoE","selected":"styles_selected__qRgK0","withBackground":"styles_withBackground__bWIWH"};